import { commonGetters } from '@/util/store-helpers';

export function withBlacklistedBy(state, getters, rootState, rootGetters) {
   const blacklists = rootGetters['companies/blacklistedTrades'];
   return state.trades.map(trade => {
      const code = parseInt(trade.code, 10);
      const blacklisted_by = blacklists[code] || [];
      return {
         ...trade,
         blacklisted_by,
      };
   });
}

const getters = commonGetters('trades', 'code');

export const {
   all, loaded, find, query, get, exists,
} = getters;
